import { render, staticRenderFns } from "./IconSortDescendingOutline.vue?vue&type=template&id=36d5c8cc"
import script from "./IconSortDescendingOutline.vue?vue&type=script&lang=js"
export * from "./IconSortDescendingOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports